
<!-- 用户管理-->
<template>
  <div>
    <x-account></x-account>
  </div>
</template>

<script>
import { account } from 'ant-design-vue-admin-x';
export default {
  name: 'account',
  components: { XAccount: account }
};
</script>
